import type {
  DocumentoNotificacao,
  ItemDetalheNotificacaoResponse,
  ResumoDocumentoNotificacao,
} from '../types/documentoNotificacao.types';
import type { ItemWithRelations } from '../types/item.types';
import { isRecord } from '@/shared/utils/apiResponse';

export function lerDocumentoNotificacao(valor: unknown): DocumentoNotificacao | null {
  if (!isRecord(valor)) return null;
  switch (valor.status) {
    case 'disponivel':
      return typeof valor.url === 'string' && valor.url.trim()
        ? { status: 'disponivel', url: valor.url }
        : null;
    case 'processando':
    case 'indisponivel':
    case 'sem_permissao':
      return { status: valor.status };
    default:
      return null;
  }
}

export function resumoDocumentoNotificacao(
  documento: DocumentoNotificacao | null | undefined,
): ResumoDocumentoNotificacao | null {
  const documentoValido = lerDocumentoNotificacao(documento);
  return documentoValido ? { status: documentoValido.status } : null;
}

export function itemSemUrlDocumento(item: ItemDetalheNotificacaoResponse): ItemWithRelations {
  return {
    ...item,
    documentoNotificacao: resumoDocumentoNotificacao(item.documentoNotificacao),
  };
}
